import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { isEmpty, uniqueId, get } from 'lodash';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import {
  StyledDialogActions,
  StyledDialogContent,
  StyledFormControl,
} from 'containers/CourtManagerLegalProceedings/TopCard/style';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';
import { COLORS } from 'constants/design';
import { CLAIM_STATUSES } from 'containers/CourtManagerLegalProceedings/constants';

export interface StatusDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  status: string;
  setStatus: Function;
  availableStatus: any;
  validateDialog: Function;
  reasonCode: any;
  setReasonCode: Function;
  listings: any;
}

const StatusDialog: React.FC<StatusDialogProps> = (props): JSX.Element => {
  const { onClose, open } = props;
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  /* istanbul ignore next */
  const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    props.setStatus(e.target.value);
    props.setReasonCode(null);
  };
  /* istanbul ignore next */
  const handleChangeReason = (e: React.ChangeEvent<{ value: unknown }>) => {
    props.setReasonCode(e.target.value);
  };
  return (
    <Dialog
      onClose={/* istanbul ignore next */ () => onClose()}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid container direction="row" spacing={1}>
          <Grid item xs={11}>
            {translate(messages.statusTitle, props)}
          </Grid>
          <Grid item>
            <CloseIconBlack
              onClick={/* istanbul ignore next */ () => onClose()}
            />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent style={StyledDialogContent}>
        <FormControl style={StyledFormControl}>
          <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
            {translate(messages.statusTitleInput, props)}
          </InputLabel>
          <Select
            name={'status'}
            value={props.status}
            onChange={handleChange}
            labelWidth={100}
          >
            {!isEmpty(props.availableStatus) &&
              props.availableStatus?.map((val: any) => (
                <MenuItem key={uniqueId('status_')} value={val}>
                  {val}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        {props.status === CLAIM_STATUSES.NOFOLLOWUP && (
          <FormControl style={StyledFormControl}>
            <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
              {translate(messages.statusReasonTitle, props)}
            </InputLabel>
            <Select
              name={'motif'}
              value={props.reasonCode}
              onChange={handleChangeReason}
              labelWidth={100}
            >
              {!isEmpty(get(props.listings, 'reasonNoFollowUp', [])) &&
                get(props.listings, 'reasonNoFollowUp', [])?.map(
                  /* istanbul ignore next */ (val: any) => (
                    <MenuItem key={uniqueId('status_')} value={val.ItemKey}>
                      {val.ItemDescription}
                    </MenuItem>
                  ),
                )}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={translate({ ...messages.dialogCancelButton }, props)}
        />
        <PrimaryButton
          onClick={() => props.validateDialog()}
          disableElevation
          data-testId="validate-button"
          title={translate({ ...messages.dialogValidationButton }, props)}
          background={COLORS.PRIMARY_BUTTON_BLUE}
          titlecolor={COLORS.WHITE}
          border={COLORS.PRIMARY_BUTTON_BLUE}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

StatusDialog.defaultProps = {
  open: false,
};

export default injectIntl(StatusDialog);
